module.exports = __webpack_public_path__ + "static/media/rotationChart.5503038b.png";